import { Component, Input, OnInit } from '@angular/core';
import { ElencoStep } from 'src/app/shared/models/node';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-checklist',
  templateUrl: './sample-checklist.component.html',
  styleUrls: ['./sample-checklist.component.scss']
})
export class SampleChecklistComponent implements OnInit {

  @Input() block: ElencoStep[] = [];
  @Input() title: any;
  @Input() subtitle: any;
  @Input() column: string = '';
  public classColumnBoxMarker: string = '';
  public classColumnText: string = '';
  public domainWebsite = environment.urlApi;

  constructor() { }

  ngOnInit(): void {
    this.setColumnItem();
  }


  setColumnItem() {
    switch (this.column) {
      case '1':
        this.classColumnBoxMarker = 'col-2 pe-3';
        this.classColumnText = 'col-10';
        break;
      default:
        this.classColumnBoxMarker = 'col-2';
        this.classColumnText = 'col-10';
        break;
    }
  }

}
